<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text">
      <p class="animate-target" v-animate-in>With simultaneous initiation of Finerenone and SGLT2i</p>
      <p class="animate-target" v-animate-in>Patients experienced an overall adverse-event profile similar to that of either agent alone<sup>1</sup>​</p>
    </div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-13/3-13-1.png" />
    <GoNext class="animate-target" v-animate-in href="/section4/">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-13",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"AE, adverse event; SAE, serious adverse event; SGLT2i, sodium-glucose cotransporter 2; TEAE, treatment-emergent adverse event.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. N Engl J Med</i>. 2025:1-11. doi:10.1056/NEJMoa2410659.",
      title:"<div class='h-image'><img class='title-logo' src='"+require('../../assets/images/p3-title-icon.png')+"' /><p>CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes<sup>1</sup></p></div>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-text {
  margin-top: 40px;
}
.ctn-text2 {
  font-size: 20px;
  display: flex;
  background-color: RGB(216 216 216 / 25%);
  padding: 15px 30px;
  align-items: center;
  width:100%;
}
.ctn-text p {
  color: #10384F;
  font-size: 20px;
}
.ctn-text p:nth-child(2) {
  font-weight: bold;
  font-size: 24px;
}
.ctn-image {
  width: 100%;
  margin-top: 30px;
}
</style>
